import { decode as base64_decode, encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

import Cookies from "js-cookie";
class DriverBehaviourSettingStore {
  driverBehavior = [];

  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      driverBehavior: observable,
      total: observable,
      loading: observable,
      loadData: action,
      addData: action,
      getDriverBehaviourSetting: action,
      deleteDriverBehaviourSetting: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId }) {
    this.loading = true;

    var postData = {
      companyId:
        JSON.parse(base64_decode(Cookies.get("data"))).isadmin === 1 ||
        JSON.parse(base64_decode(Cookies.get("data"))).isadmin === 0
          ? Number(JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId)
          : null,
      offset: offset,
      limit: limit,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=driverbsetting&a=getDriverBSettings",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/driver/getDriverBehaviourData", {
        params: postData,
      });
    this.driverBehavior = response?.data?.data;

    this.loading = false;
  }

  async addData(DBData) {
    var postData = {
      companyId: DBData.companyId,
      minMileage: DBData.minMileage,
      topScore: DBData.topScore,
      absValue: DBData.absValue,
      custScore: DBData.custScore,
      harshAcce: DBData.harshAcce,
      harshBrack: DBData.harshBrack,
      exIdeling: DBData.exIdeling,
      speeding: DBData.speeding,
      rpmExcess: DBData.rpmExcess,
      seatBelt: DBData.seatBelt,
      id: DBData.id,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // const response = await postApi
    //   .getClient()
    //   .post("index.php?c=driverbsetting&a=update", "postData=" + base64Input);
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/driver/addDriverBehaviourData", { postData });

    return response.data;
  }

  async getDriverBehaviourSetting(id) {
    var postData = { bid: id, limit: 1, offset: 0 };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=driverbsetting&a=getDriverBSettings",
    //     "postData=" + base64Input
    //   );

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/driver/getDriverBehaviourData", {
        params: postData,
      });
    return response.data.data[0];
  }

  async deleteDriverBehaviourSetting({ id }) {
    // var postData = {
    //   tokenId: "80bovn8u800tg1aq9bvr73kbhh",
    //   FuelDetails: {},
    //   id: id,
    // };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=driverbsetting&a=delete", "postData=" + base64Input);

    const response = await postApi
      .getClient("")
      .delete(config.NodeUrl + "/driver/deleteDriverBehaviourData", {
        params: { id: id },
      });
    return response;
  }
}

export default DriverBehaviourSettingStore;
